export const formatNumber = (num) => {
    const number = parseFloat(num);
    return !isNaN(number) ? number.toFixed(2) : '0.00';
};

export const val = (v) => (v !== undefined && v !== null ? v.toFixed(2) : '0');

export const safeDivide = (numerator, denominator) => {
    if (!denominator) return 0;
    return numerator / denominator;
};
